import { createSlice } from "@reduxjs/toolkit";
import BaseState from "../../interfaces/state/BaseState";

interface docsState extends BaseState {
  selectedIndex: number;
}

const initialState: docsState = {
  selectedIndex: 0,
  loading: false,
};

export const docsSlice = createSlice({
  name: "docs",
  initialState,
  reducers: {
    setSelectedIndex: (state, action) => {
      state.selectedIndex = action.payload;
    },
  }
});

export const { setSelectedIndex } = docsSlice.actions;